import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ProductCertificationApi } from 'api';

export const createProductCertification = createAsyncThunk(
  'productCertification/createProductCertification',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await ProductCertificationApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateProductCertification = createAsyncThunk(
  'productCertification/updateProductCertification',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await ProductCertificationApi.update(params);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeProductCertification = createAsyncThunk(
  'productCertification/removeProductCertification',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await ProductCertificationApi.remove(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

const productCertificationSlice = createSlice({
  name: 'productCertification',
  initialState: {
    tableList: [],
    list: [],
  },
  reducers: {},
  //   extraReducers: builder => {},
});

const { reducer: productCertificationReducer } = productCertificationSlice;

export default productCertificationReducer;
